/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Fix: le carousel Flickity des vignettes produit (thumbnails) centre les
  // cellules au lieu de les coller a gauche quand il y a peu de photos
  // (cellAlign par defaut = 'center' dans theme.js, non configurable sans
  // editer le bundle). On corrige l'instance deja creee, et on reapplique a
  // chaque (re)init du carousel (ex: resize desktop/mobile) en observant la
  // classe "flickity-enabled" que Flickity ajoute a chaque init.
  var thumbsEl = document.querySelector('[data-product-single-media-thumbs]');

  if (thumbsEl && window.themeVendor && window.themeVendor.Flickity) {
    var fixThumbsAlign = function() {
      var flkty = themeVendor.Flickity.data(thumbsEl);
      if (flkty && flkty.options.cellAlign !== 'left') {
        flkty.options.cellAlign = 'left';
        flkty.resize();
      }
    };

    new MutationObserver(fixThumbsAlign).observe(thumbsEl, {
      attributes: true,
      attributeFilter: ['class']
    });

    fixThumbsAlign();
  }



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
